const exportDocument = (src, tab) => window.open(src,!!tab ? null: "_self");

export default exportDocument;